// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-tjssi{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-siavi{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-nixsk{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bhpzl{grid-column:span 3}.assets-scss-gridstyleGrid-col4-blcgo{grid-column:span 4}.assets-scss-gridstyleGrid-col9-bjqte{grid-column:span 9}.assets-scss-gridstyleGrid-col12-gjsjn{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-bloob{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-tjssi",
	"grid": "assets-scss-gridstyleGrid-grid-siavi",
	"col6": "assets-scss-gridstyleGrid-col6-nixsk",
	"col3": "assets-scss-gridstyleGrid-col3-bhpzl",
	"col4": "assets-scss-gridstyleGrid-col4-blcgo",
	"col9": "assets-scss-gridstyleGrid-col9-bjqte",
	"col12": "assets-scss-gridstyleGrid-col12-gjsjn",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-bloob"
};
module.exports = ___CSS_LOADER_EXPORT___;
